// Demo data + pre-rendered result blocks for the "Demo ausprobieren" flow.
// Used by CoCreator (wizard pre-fill) and CoCreatorResult (final blocks).

export const DEMO_STEP_DATA = {
  // Step 0 - Goal
  0: {
    goal:
      "Das Team setzt die neue Freigabe-Regel ab Montag um — ohne Widerstand.",
    successMetric: "3 von 5 bestätigen bis Freitag.",
    mustHave: "Klare, faire Kommunikation ohne Bevormundung.",
  },
  // Step 1 - Cat
  1: {
    audience: "Kleines Team",
    emotionalBenefit:
      "Weniger Hin-und-Her, klarere Spielführung, endlich durchziehen, was seit Monaten gewollt ist.",
    options:
      "Drei Wege, das anzulegen — das Team entscheidet, welcher passt.",
    tone: "Locker, direkt. Nicht: 'müssen', 'sollen', 'ab sofort'.",
  },
  // Step 2 - Owl
  2: {
    bigPicture:
      "Q3: 3 Kunden abgesprungen wegen langer Angebotsdurchlaufzeit. Markt hat sich verändert.",
    facts:
      "Stage-Gating-Studien zeigen 20-30% kürzere Vertriebszyklen. Wettbewerber sind schon weiter.",
    relevance:
      "Q4-Pipeline hängt daran. Ohne neuen Prozess verlieren wir zwei Verträge.",
  },
  // Step 3 - Bee
  3: {
    todos: "Anfragen über 5k € durch neuen Freigabe-Prozess.",
    watchOuts: "Vorlage nutzen spart Rückfragen. Klare Rollen-Zuordnung.",
    steps:
      "1. Anfrage einreichen (mit Vorlage). 2. Approval durch Sales-Leitung. 3. Versand innerhalb 48h.",
    successSignals: "Jede Anfrage über 5k € hat innerhalb 24h eine erste Antwort.",
  },
  // Step 4 - Dog
  4: {
    personalConsequence:
      "Wer den Prozess nicht nutzt, blockiert die Team-Pipeline.",
    ifThen:
      "Tun: Pipeline gesichert, Team entlastet ab November. Nicht tun: 2 unterschriftsreife Verträge kippen, Q4-Ergebnis in Gefahr.",
    consequencesForOthers:
      "Drei Kollegen in der Umsetzung stehen ohne Folgeauftrag da, wenn es nicht klappt.",
    nextAction:
      "Bis Freitag kurze Bestätigung an mich, dass der Prozess verstanden ist.",
  },
};

// Flat merge of all demo step data
export const DEMO_FULL_DATA = Object.values(DEMO_STEP_DATA).reduce(
  (acc, obj) => ({ ...acc, ...obj }),
  {}
);

// Pre-rendered result blocks for the demo (German, no LLM call)
export const DEMO_RESULT_BLOCKS = {
  cat:
    "Ich weiß, Prozessregeln sind nervig. Diese hier gibt dir aber etwas zurück: weniger Hin-und-Her, klarere Spielführung, und du ziehst endlich durch, was du seit Monaten willst. Drei Wege, das anzulegen — du entscheidest, welcher in deinen Alltag passt.",
  owl:
    "Im Q3 sind drei Kunden abgesprungen, weil wir intern zu lange für Angebote gebraucht haben. Studien zeigen: konsequentes Stage-Gating verkürzt Vertriebszyklen um 20-30 Prozent. Wer das jetzt nicht umsetzt, verliert im Q4 weiter an Geschwindigkeit.",
  bee:
    "Ab Montag: Anfragen über 5.000 Euro durch den neuen Freigabe-Prozess. Schritt 1: Anfrage einreichen (Vorlage nutzen). Schritt 2: Approval durch Sales-Leitung. Schritt 3: Versand innerhalb von 48 Stunden. Tipp: Wer die Vorlage nutzt, spart sich Rückfragen.",
  dog:
    "Wenn wir das nicht machen, kippen zwei unterschriftsreife Verträge — und drei Kollegen in der Umsetzung stehen ohne Folgeauftrag da. Nächster Schritt: bis Freitag kurze Bestätigung an mich, dass der Prozess verstanden ist.",
};
